module.exports = __webpack_public_path__ + "static/media/world white.8b4114b3.png";